<template>

<div class="main-div" v-bind:class="{ 'bottom-left': !showDetail, 'top-left': showDetail }" v-if="isWorking || isRosterRoute">
   
    <b-button class="square-button" v-if="!showDetail"  @click="showDetail = !showDetail"><i class="cog-icon fa-2x" v-bind:class="{'fas fa-cog fa-spin': isWorking, 'fas fa-cog': !isWorking}"></i></b-button>
    <b-container fluid v-if="showDetail">
        <b-card>
            <template v-slot:header>
                <b-row>
                    <b-col>
                        <h6 class="mb-0">Auto. Ergebnisse </h6>
                    </b-col>
                     <b-col cols=1>
                        <i class="fas fa-times" @click="showDetail = !showDetail"></i>
                        
                    </b-col>
                    
                </b-row>
                
                
            </template>
            <b-row>
                <b-col>
                    <b-table small striped hover :sticky-header="detailHeight" :borderless="true" :outlined="false" :items="rosterOptions" :fields="rosterFields" selectable select-mode="single" @row-selected="onRowSelected">
                            <template slot="state" slot-scope="row">
                                <i v-bind:class="{'fas fa-cog fa-spin': row.item.state.val== 0 || row.item.state.val==1, 'fas fa-check': row.item.state.val == 2, 'fas fa-times': row.item.state.val == 3, 'fas fa-clock': row.item.state.val == 4}"></i>
                            </template>
                            <template slot="ruleProfileLabel" slot-scope="row">
                                <p v-if="ruleProfileMap[row.item.ruleProfileId] != null">{{ruleProfileMap[row.item.ruleProfileId].labelDe}}</p>
                            </template>
                            <template slot="runtimeLabel" slot-scope="row">
                                {{row.item.runtime/60}} Min.
                            </template>
                            <template slot="actions" slot-scope="row">
                                    <b-button class="mx-1" size="sm" variant="success" v-if="isRosterRoute && selectedRosterId == row.item.id" v-on:click="loadRosterResultPreview()"><i class="fas fa-eye"></i></b-button>
                                    <b-button class="mx-1" size="sm" variant="success" v-if="isRosterRoute && selectedRosterId == row.item.id && rosterResult.id == selectedRosterId" v-on:click="applyRosterResult()"><i class="fas fa-arrow-alt-circle-up"></i></b-button> 
                                    <b-button class="mx-1" size="sm" v-if="selectedRosterId == row.item.id && (rosterResultMap[selectedRosterId].state === 0 || rosterResultMap[selectedRosterId].state === 1)" variant="warning" v-on:click="openModal(selectedRosterId, 'modal-stoproster')"><i class="fas fa-stop-circle"></i></b-button>
                                    <b-button class="mx-1" size="sm" v-if="selectedRosterId == row.item.id && (rosterResultMap[selectedRosterId].state === 2 || rosterResultMap[selectedRosterId].state === 3 || rosterResultMap[selectedRosterId].state === 4)" variant="danger" v-on:click="openModal(selectedRosterId, 'modal-deleteroster')"><i class="fas fa-trash"></i></b-button>
                            </template>
                    </b-table>
                </b-col>
                
                
            </b-row>
        </b-card>
    </b-container>
    
    <b-modal ref="modal-deleteroster"  no-close-on-backdrop no-close-on-esc centered title="Plan Ergebnis löschen" @cancel="hideModal('modal-deleteroster')" @ok="deleteRoster" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie das Ergebnis löschen wollen?</p>
            </b-row>
            <b-row v-if="error" class="my-1">
                Fehler beim Löschen des Ergebnisses.
            </b-row>
        </b-container>
    </b-modal>
    <b-modal ref="modal-stoproster"  no-close-on-backdrop no-close-on-esc centered title="Planung stoppen" @cancel="hideModal('modal-stoproster')" @ok="stopRoster" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die Planung stoppen wollen?</p>
            </b-row>
            <b-row v-if="error" class="my-1">
                Fehler beim Stoppen der Planung.
            </b-row>
        </b-container>
    </b-modal>

</div>

</template>

<script>
import * as SockJS from 'sockjs-client';
import * as EventBus from 'vertx3-eventbus-client';
import VueEventBus from '../../vue-event-bus';

const moment = require('moment');
export default {
    name: 'rosterresult',
    components: {
    },
    data () {
        return {
            windowHeight: window.innerHeight,
            rosterOptions: [],
            ruleProfileMap: {},
            showDetail: false,
            rosterFields: [{key:"creationDate", label:"Plan-Datum", sortable: false, thClass: 'documentsTh', tdClass: 'documentsTd'},
                           {key:"from", label:"Von", sortable: false, thClass: 'documentsTh', tdClass: 'documentsTd'},
                           {key:"to", label:"Bis", sortable: false, thClass: 'documentsTh', tdClass: 'documentsTd'}, {key: "ruleProfileLabel", label: "Regel Profil", thClass: 'documentsTh', tdClass: 'documentsTd'}, 
                           {key: "runtimeLabel", label: "Laufzeit", thClass: 'documentsTh', tdClass: 'documentsTd'},
                           {key:"state", label:"Status", sortable: false, thClass: 'documentsTh', tdClass: 'documentsTd'},
                           {key:"unassignedShifts", label:"Schichten", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'}, 
                           {key: "actions", label: "", thClass: 'documentsTh', tdClass: 'documentsTd'}],
            selectedRosterId: null,
            spotMap: {},
            shiftMap: {},
            employeeMap: {},
            rosterResultMap: {},
            rosterResult: {},
            updateableShiftIds: [],
            error: false,
            errorMsg: "",
            eventBus: null,
        }
    },
    computed: {
            loginStatus() {
                return this.$store.state.loggedIn;
            },
            rosterResultFromTo() {
                if(this.$store.state.loggedIn){
                    return this.$store.state.rosterFromTo;
                } else {
                    return null;
                }
                
            },
            detailHeight() {
                return (this.windowHeight-112)*0.6+'px';
            },
            storeId() {
                return this.$store.state.storeId;
            },
            stateLabel() {
               if(this.selectedRosterId){
                   let state = this.rosterResultMap[this.selectedRosterId].state;
                   if(state === 0 || state === 1){
                        return "In Bearbeitung";
                    }
                    if(state === 2 ){
                        return "Fertig";
                    }
                    if(state === 3 ){
                        return "Fehlgeschlagen";
                    }
                    if(state === 4 ){
                        return "Gestoppt";
                    }
               } else {
                   return null;
               }
            },
            isRosterRoute() {
                return this.$route.name == "roster";
            },
            isWorking() {
                let isWorking = false;
                for(let resultId in this.rosterResultMap){
                    if(this.rosterResultMap[resultId].state === 0 || this.rosterResultMap[resultId].state === 1){
                        isWorking = true;
                        break;
                    }
                }
                return isWorking;
            }
            
    },
    watch: {
            rosterResultFromTo(newVal, oldVal) {
                if(newVal != null){
                   if(this.$route.name === 'roster'){
                        this.loadRosters();
                   } 
                }
            },
            storeId(newVal, oldVal) {
                if(this.eventBus != null){
                    this.eventBus.close();
                    this.setupEventBus();
                }
                this.loadRosters();
            },
            selectedRosterId(newVal, oldVal) {
                if(newVal != null){
                    this.loadRosterResult();
                }
            }
    },
    created: function () {
            //listen to vue eventbus for events from wizard
            VueEventBus.$on("autoscheduling-submitted", this.reloadRosterResultListener);
            this.setupEventBus();
    },
    mounted: function() {
        
        if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined && this.$store.state.rosterFromTo != null){
            this.loadRosters();
            let view = this;
            this.loadRuleProfiles()
            .then(response=> {
                view.updateRuleProfiles(response.data);
            }).catch(error => {
                console.log(error);
            });
        }
        window.addEventListener('resize', this.onResizeWindow);
    },
    beforeDestroy() {
        VueEventBus.$off("autoscheduling-submitted", this.reloadRosterResultListener);
        window.removeEventListener('resize', this.onResizeWindow);
        if(this.eventBus != null){
            console.log("closing eventbus bridge");
            this.eventBus.close();
        }
    },
  // methods that implement data logic.
  methods: {
    onResizeWindow() {
        this.windowHeight = window.innerHeight;
    },
    onRowSelected(items){
        if(items.length > 0){
            this.selectedRosterId = items[0].id;
        } else {
            this.selectedRosterId = null;
        }
       
    },
    abortStage: function(){
        this.state = this.state-1;
    },
    reloadRosterResultListener: function(payload) {
        if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined && this.$store.state.rosterFromTo != null){
            this.showDetail = true;
            this.loadRosters();

        } 
    },
    setupEventBus : function (id, shareKey) {
            let view = this;
            let options = {
                vertxbus_reconnect_attempts_max: Infinity, // Max reconnect attempts
                vertxbus_reconnect_delay_min: 5000, // Initial delay (in ms) before first reconnect attempt
                vertxbus_reconnect_delay_max: 300000, // Max delay (in ms) between reconnect attempts
                vertxbus_reconnect_exponent: 2, // Exponential backoff factor
                vertxbus_randomization_factor: 0.5 // Randomization factor between 0 and 1
            };
            this.eventBus = new EventBus('/eventbus', options);
            this.eventBus.enableReconnect(true);
			this.eventBus.onclose = function (e) {
				
			};
			this.eventBus.onopen = function() {
                let token = view.$store.state.jwt;
                let storeId = Number(view.$store.state.storeId);
                let headers = { token: token, storeId: storeId};
                let rosterResultAddress = 'out-rr:'+storeId;
				view.eventBus.send('sockjsauth', '', headers,  function(error, message){
                    
                    if(message != null && message.body != null){
                       if(message.body === 'OK'){
                           view.eventBus.unregisterHandler(rosterResultAddress);
                           view.eventBus.registerHandler(rosterResultAddress, headers, view.eventBusRosterResultCallback);
                       } else {
                           console.log(JSON.stringify(message));
                       }
                        
                    } else if(error != null){
                        console.log(JSON.stringify(error));
                    }
			
		        });
			}
			this.eventBus.onerror = function (error) {
				  console.log("Problem calling event bus " + JSON.stringify(error))
			};
			
			 
    },
    eventBusRosterResultCallback: function(error, message) {
        if(message != null && message.body != null){
            let rosterResult = message.body;
            this.updateRosterState(rosterResult);
            if(this.rosterResult.id == rosterResult.id){
                let view = this;
                this.rosterResult = rosterResult;
                
                let payload = { ids: []};
                var i;
                for (i = 0; i < this.rosterResult.data.roster.shiftList.length; i++) {
                    let timeSlotId = this.rosterResult.data.roster.shiftList[i].timeSlotId
                    let originalRequestId = this.rosterResult.data.roster.timeSlotMap[timeSlotId].originalRequestId
                    let shiftId = this.rosterResult.data.roster.customEntityMapping.shiftMapping[originalRequestId].originalId
                    payload.ids.push(shiftId);
                }
                this.updateRosterShifts(payload, this.rosterResult)
                .catch(error => {
                    view.error = true;
                    if(error.msg != null){
                        view.errorMsg = error.msg;
                    } else {
                        console.log(error);
                        view.errorMsg = "Fehler beim Laden des Plans!"
                    }
                });
            }         
                        
        } else if(error != null){
            console.log(JSON.stringify(error));
        }
    },
    loadRuleProfiles : function() {
       
        let url = '/api/sec/ruleprofile';

        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/ruleprofile');
            

         return this.axios({
             method: 'get',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).catch(error => 
            Promise.reject({msg: "Fehler beim Laden der Regel Profile"})
        )
         
    },
    updateRuleProfiles: function(data){
        let tRuleProfileMap = {};
        for(let i = 0; i<data.length; i++){
            tRuleProfileMap[data[i].id] = data[i];
        }
        this.ruleProfileMap = tRuleProfileMap;
    },
    loadRosters : function() {
        if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined 
            && this.$store.state.rosterFromTo != null && this.$store.state.rosterFromTo.from != null && this.$store.state.rosterFromTo.to != null){
            let view = this;
            this.rosterResult = {};
            this.selectedRosterId = null;

            let url = '/api/sec/employeeroster';

            let params = {
                storeId: this.$store.state.storeId,
                from: this.$store.state.rosterFromTo.from,
                to: this.$store.state.rosterFromTo.to,
            };

            this.axios({
                method: 'get',
                params: params,
                headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                url: url
            }).then(response => {
                let trosterOptions = [];
               
                
                let rosterResultMap = {};
                for (let i = 0; i < response.data.length; i++) { 
                    rosterResultMap[response.data[i].id] = response.data[i];
                    let state = {val: response.data[i].state, label: ""};
                    if(response.data[i].state === 0 || response.data[i].state === 1){
                        state.label = "In Bearbeitung";
                    }
                    if(response.data[i].state === 2 ){
                        state.label = "Fertig";
                    }
                    if(response.data[i].state === 3 ){
                        state.label = "Fehlgeschlagen";
                    }
                    if(response.data[i].state === 4 ){
                        state.label = "Gestoppt";
                    }
                    
                    let tOption = { id: response.data[i].id, creationDate: moment(response.data[i].creationDate).format("DD.MM.YYYY HH:mm"), 
                                    from: moment(response.data[i].from).format("DD.MMM"), 
                                    to: moment(response.data[i].to).format("DD.MMM"), state: state, runtime: response.data[i].runtime, 
                                    ruleProfileId: response.data[i].ruleProfileId,
                                    unassignedShifts: response.data[i].unassignedShifts,
                                    value: response.data[i]}
                    trosterOptions.push(tOption);
                }
                view.rosterResultMap = rosterResultMap;
                view.rosterOptions = trosterOptions;
                view.error = false;
                view.state = 1; 
            }).catch(function (error) {
                console.log(error);
            })
        }
        
    },
    updateRosterState: function(rosterResult) {
        
        const index = this.rosterOptions.findIndex(roster => roster.id === rosterResult.id);
        this.rosterResultMap[rosterResult.id].state = rosterResult.state;
        this.rosterOptions[index].state.val = rosterResult.state;
        this.rosterResultMap[rosterResult.id].unassignedShifts = rosterResult.unassignedShifts;
        this.rosterOptions[index].unassignedShifts = rosterResult.unassignedShifts;
        
        if(rosterResult.state === 0 || rosterResult.state === 1){
            this.rosterOptions[index].state.label = "In Bearbeitung";
        }
        if(rosterResult.state === 2 ){
            this.rosterOptions[index].state.label = "Fertig";
        }
        if(rosterResult.state === 3 ){
            this.rosterOptions[index].state.label = "Fehlgeschlagen";
        }
        if(rosterResult.state === 4 ){
             this.rosterOptions[index].state.label = "Gestoppt";
        }

    },
    loadRosterResultPreview: function() {
        if(this.selectedRosterId != null && this.rosterResultMap[this.selectedRosterId] != null){
            let view = this;
            this.loadRosterResult(this.selectedRosterId)
            .then(response => {
                this.rosterResult = response.data;
                view.updateRosterState(this.rosterResult);
            
                
                let payload = { ids: []}
                var i;
                for (i = 0; i < this.rosterResult.data.roster.shiftList.length; i++) {
                    let timeSlotId = this.rosterResult.data.roster.shiftList[i].timeSlotId
                    let originalRequestId = this.rosterResult.data.roster.timeSlotMap[timeSlotId].originalRequestId
                    let shiftId = this.rosterResult.data.roster.customEntityMapping.shiftMapping[originalRequestId].originalId
                    payload.ids.push(shiftId);
                }
                return this.updateRosterShifts(payload, this.rosterResult);
            }).catch(error => {
                view.error = true;
                if(error.msg != null){
                    view.errorMsg = error.msg;
                } else {
                    console.log(error);
                    view.errorMsg = "Fehler beim Laden des Plans!"
                }
            })
        }
        
        
    },
    updateRosterShifts: function(payload, rosterResult){
        let view = this;
        return this.loadShiftsAny(payload).then(response=>{
            let tShiftMap = {};
            for (let i = 0; i < response.data.length; i++) { 
                tShiftMap[response.data[i].id] = response.data[i]
            }
            view.shiftMap = tShiftMap;
            let payload = { ids: []}
            
            for (var p in rosterResult.data.roster.employeeMap) {
                if (rosterResult.data.roster.employeeMap.hasOwnProperty(p)) {
                    let resultEmployeeId = rosterResult.data.roster.employeeMap[p].id;
                    let shiftId = rosterResult.data.roster.customEntityMapping.employeeMapping[resultEmployeeId].originalId
                    payload.ids.push(shiftId);
                }
                
            }
            return this.loadEmployeesAny(payload);
        }).then(response=>{
            
            let tEmployeeMap = {};
            for (let i = 0; i < response.data.length; i++) { 
               tEmployeeMap[response.data[i].id] = response.data[i]
            }
            view.employeeMap = tEmployeeMap;

            //link employees in roster result to shifts map and create array for display table
            let tShifts = [];
            let updateableShiftIds = [];
            for (let i = 0; i < rosterResult.data.roster.shiftList.length; i++) {
                let timeSlotId = rosterResult.data.roster.shiftList[i].timeSlotId
                let originalRequestId = rosterResult.data.roster.timeSlotMap[timeSlotId].originalRequestId
                let shiftId = rosterResult.data.roster.customEntityMapping.shiftMapping[originalRequestId].originalId
                if(view.shiftMap[shiftId] != null){
                    let resultEmployeeId = rosterResult.data.roster.shiftList[i].employeeId;
                    if(view.rosterResult.data.roster.customEntityMapping.employeeMapping[resultEmployeeId] != null){
                        view.shiftMap[shiftId].employeeId = rosterResult.data.roster.customEntityMapping.employeeMapping[resultEmployeeId].originalId;
                    } else {
                        view.shiftMap[shiftId].employeeId = null;
                    }
                    if(!rosterResult.data.roster.shiftList[i].lockedByUser){
                        updateableShiftIds.push(shiftId);
                    }

                }
            }
            for(let shiftId in view.shiftMap){
                tShifts.push(view.shiftMap[shiftId])
            }
            view.updateableShiftIds = updateableShiftIds;
            
            VueEventBus.$emit("preview-autoroster-result", tShifts);
            view.error = false;
           
        });
    },
    applyRosterResult : function() {
        let view = this;
        let url = '/api/sec/planshift/multi';

        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planshift/multi');

        let payload =  {
            requests: [],
        }

        for(let i = 0; i<this.updateableShiftIds.length; i++){
            let shift = this.shiftMap[this.updateableShiftIds[i]];
            let request = {
                updateFields: ["employeeId"],
                id: shift.id,
                employeeId: shift.employeeId
            }
            payload.requests.push(request); 
        }
        
        if(payload.requests.length > 0){
            this.axios({
                method: 'put',
                headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                url: url,
                data: payload
            }).then(response => {
                VueEventBus.$emit('apply-autoroster-result');
            }).catch(function (error) {
                console.log(error);
            })
        } else {
            VueEventBus.$emit('apply-autoroster-result');
        } 
    },
    loadRosterResult: function(id) {
      let url = '/api/sec/employeeroster';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeroster');
      url = this.$helpers.appendParam("id", id, url, '/api/sec/employeeroster');

      return this.axios({
        method: 'get',
        headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
        url: url
      }).catch(error => 
         Promise.reject({msg: "Fehler beim Laden des Plan Ergebnisses"})
      )
    },
    openModal: function(id, modal){
        this.selectedRosterId = id;
        this.showModal(modal)
    },
    deleteRoster: function() {
      let url = '/api/sec/employeeroster';
      let view = this;
      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeroster');
      url = this.$helpers.appendParam("id", this.selectedRosterId, url, '/api/sec/employeeroster');

      this.axios({
        method: 'delete',
        headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
        url: url
      }).then(response => {
        const index = view.rosterOptions.findIndex(roster => roster.id === view.selectedRosterId)
        
        if (~index) {
            view.rosterOptions.splice(index, 1);
        } 
        
          
        view.hideModal('modal-deleteroster');

      }).catch(error => {
          
          this.error = true;
          this.errorMsg = "Fehler beim Löschen des Plan Ergebnisses"
      })
    },
    stopRoster: function() {
      let url = '/api/sec/employeeroster/stop';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeeroster/stop');
      url = this.$helpers.appendParam("id", this.selectedRosterId, url, '/api/sec/employeeroster/stop');

      this.axios({
        method: 'put',
        headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
        url: url
      }).then(response => {
        const index = this.rosterOptions.findIndex(roster => roster.id === this.selectedRosterId)
        
        this.rosterOptions[index].state.val = 4;
        this.rosterOptions[index].state.label = "Gestoppt";
          
        this.hideModal('modal-stoproster');

      }).catch(error => {
          this.error = true;
          this.errorMsg = "Fehler beim Stoppen des Plans"
      })
    },
    loadSpotsAny : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/spot/any';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/spot/any');
            

            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).catch(error => 
                Promise.reject({msg: "Fehler beim Laden der Positionen"})
            )
        } 
    },
    loadShiftsAny : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/planshift/any';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planshift/any');
           

            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).catch(error => 
                Promise.reject({msg: "Fehler beim Laden der Schichten"})
            )
        } 		
    },
    loadEmployeesAny : function(payload) {
        if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
            return new Promise((resolve, reject) => {
                resolve({data:[]});
            })
        } else {
            let url = '/api/sec/employee/any';

            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee/any');

            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).catch(error => 
                Promise.reject({msg: "Fehler beim Laden der Mitarbeiter"})
            )
        } 			
    },
    extractDate: function(str){
        if(!this.$helpers.isBlank(str)) {
            let split = str.split("T");
            return split[0];
        } else {
            return null;
        }
    },
    extractTime: function(str){
        if(!this.$helpers.isBlank(str)) {
            let split1 = str.split("T");
            let split2 = split1[1].split(":")
            return split2[0]+":"+split2[1];
        } else {
            return null;
        } 
    },
    getMinuteDiff: function(dt2, dt1) {
        var diff =(dt2.getTime() - dt1.getTime()) / 1000;
        diff /= 60;
        return Math.abs(Math.round(diff));
    },
    hideModal (ref) {
        this.showDetail = true;
        this.error=false;
        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.showDetail = false;
        this.$refs[ref].show()
    }

  }

}
</script>

<!-- Add "scoped" attrispotte to limit CSS to this component only -->
<style scoped>
.main-div {
    display: inline-block;
    position: fixed;  
}
.cog-icon {
    color: #404040;
}
.bottom-left {
    z-index: 10000;
    top: auto;
    left: auto;
    bottom: 124px;
    right: 36px;
}
.top-left {
    z-index: 1000000;
    width: 40%;
    top: 110px;
    left: auto;
    bottom: auto;
    right: 36px;
}
.square-button {
    height: 52px !important;
    width: 52px !important;
    padding-top: 0rem;
    padding-right: 0rem;
    padding-bottom:0rem;
    padding-left: 0rem;
    background-color: #c1c1c1;
    border-color: #c1c1c1;
    
}
.close-button {
    height: 20px !important;
    width: 20px !important;
}

</style>
